import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 39,
  medium: 29,
  small: 19,
  xSmall: 16
};
const MuteIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: `0 0 30 30`,
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M0.5 9.3986L5.44133 9.3982L6.61255 10.3985L1.5 10.3981V19.6011L7.52837 19.6015L13.5 23.1241V16.281L14.5 17.135V24.8756L7.254 20.6011L0.5 20.6015V9.3986Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { d: "M13.5 6.87505V11.0206L14.5 11.8747V5.12455L9.82492 7.88179L10.6294 8.56886L13.5 6.87505Z", fill: "currentColor" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M19.5808 16.2141L20.4501 16.9566C20.7137 16.358 20.86 15.6961 20.86 15.0001C20.86 12.9067 19.5365 11.1224 17.6806 10.4385L17.3071 11.4522C18.7506 11.9841 19.78 13.3719 19.78 15.0001C19.78 15.4247 19.71 15.8331 19.5808 16.2141Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M18.801 22.6027C19.2721 22.4291 19.7227 22.2129 20.148 21.9588L21.0091 22.6943C20.4383 23.0666 19.8236 23.3771 19.1744 23.6164L18.801 22.6027Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M22.978 19.1156L23.8103 19.8265C24.6787 18.4242 25.18 16.7707 25.18 15.0001C25.18 11.0459 22.68 7.67568 19.1744 6.38372L18.801 7.39741C21.8941 8.53737 24.1 11.5111 24.1 15.0001C24.1 16.5026 23.6909 17.9095 22.978 19.1156Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M20.2948 26.6574C21.4739 26.2229 22.569 25.6145 23.5488 24.8635L24.387 25.5794C23.2762 26.4612 22.0234 27.1717 20.6683 27.6711L20.2948 26.6574Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M26.2956 21.9491L27.1217 22.6546C28.6217 20.4793 29.5 17.8423 29.5 15.0001C29.5 9.18515 25.8236 4.22892 20.6683 2.32898L20.2948 3.34267C25.0377 5.09061 28.42 9.65034 28.42 15.0001C28.42 17.5744 27.6368 19.9659 26.2956 21.9491Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { d: "M1.44361 2.7952L0.795145 3.55644L28.5564 27.2049L29.2049 26.4437L1.44361 2.7952Z", fill: "currentColor" })
  );
};
MuteIcon.iconName = "MuteIcon";

export { MuteIcon };
